import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h1>{`Hi, I'm Itsik Yehuda`}</h1>
    <p>{`I'm creating noice web experiences for the next generation of consumer-facing companies`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      